import React, {Component} from 'react'
import Landing from './Landing'

function Gallery() {
    
    /* return (
        <div>
            <Landing />
            <iframe
                src='https://snapwidget.com/embed/690574'
                className='snapwidget-widget widget-wide'
                allowtransparency='true'
                frameBorder='0'
                scrolling='yes'>
            </iframe>
            <iframe
                src='https://snapwidget.com/embed/690576'
                className='snapwidget-widget widget-narrow'
                allowtransparency='true'
                frameBorder='0'
                scrolling='yes'>
            </iframe>
        </div>
    ) */
}

export default Gallery